import './src/fonts/fonts.css';

import React from 'react';
import { navigate } from 'gatsby';
import { PageProvider } from './src/contextProvider/PageContext';
import { ToastProvider } from './src/contextProvider/ToastContext';

// eslint-disable-next-line import/prefer-default-export
export const wrapPageElement = ({ element, props }) => {
  if (props?.pageResources?.page?.path === '/404.html') {
    navigate('/404');
  }
  return (
    <PageProvider value={props}>
      <ToastProvider values={null}>{element}</ToastProvider>
    </PageProvider>
  );
};
